/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_button_try_demo = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Demo`)
};

const zh_hans1_button_try_demo = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用演示`)
};

const zh_hant1_button_try_demo = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試用示範`)
};

const fr_button_try_demo = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayer la démo`)
};

const de_button_try_demo = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo ausprobieren`)
};

const ja_button_try_demo = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デモを試す`)
};

const ko_button_try_demo = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`데모 사용해 보기`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const button_try_demo = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.button_try_demo(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("button_try_demo", locale)
	if (locale === "en") return en_button_try_demo(inputs)
	if (locale === "zh-Hans") return zh_hans1_button_try_demo(inputs)
	if (locale === "zh-Hant") return zh_hant1_button_try_demo(inputs)
	if (locale === "fr") return fr_button_try_demo(inputs)
	if (locale === "de") return de_button_try_demo(inputs)
	if (locale === "ja") return ja_button_try_demo(inputs)
	return ko_button_try_demo(inputs)
};